import AbstractValidator from './abstractValidator';
import TabletopItem from '../item/tabletopItem';

/**
 * @class CollisionValidator
 * @extends AbstractValidator
 */
export default class TabletopCollisionValidator extends AbstractValidator {
    /**
     * @param {ProblemFactory} problemFactory
     * @param {TabletopCollisionChecker} tabletopCollisionChecker
     * @param {string} message
     * @param {string} problemType
     */
    constructor(problemFactory, tabletopCollisionChecker, message) {
        super(problemFactory);

        this.tabletopCollisionChecker = tabletopCollisionChecker;
        this.message = message;
    }

    /**
     * Validates a single non-group item
     *
     * @param {AbstractItem} item
     * @return {AbstractProblem[]}
     * @private
     */
    _validateSingleItem(item) {
        if (!this._isItemSupported(item)) return [];

        return this
            .tabletopCollisionChecker
            .check(item)
            .map(collision => this._createProblemForCollision(collision));
    }

    /**
     * @param {AbstractCollision} collision
     * @return {AbstractProblem}
     * @private
     */
    _createProblemForCollision(collision) {
        return this
            .problemFactory
            .createCollisionError(
                'collision',
                this.message,
                'warning-sign',
                [collision.item, collision.otherItem],
                collision,
            );
    }

    _isItemSupported(item) {
        return item.hasParentItem() && item.getParentItem() instanceof TabletopItem;
    }
}
